import { CustomsUserType } from './CustomsUserInformation.js';
import { Address } from '../../../models/Address/Address.js';

const commonAddressProps = {
  email: null,
  street2: null,
  surname: '',
  country: '',
  id: undefined
};
class CustomsUserInformationMapper {
  static createModelFromResponse(response) {
    return {
      address: this.createCustomsAddressFromResponse(response.data),
      taxInformation: this.createTaxInformationFromResponse(response.data)
    };
  }
  static createCustomsAddressFromResponse(address) {
    if (!address) {
      return undefined;
    }
    return Address.createFromResponse({
      ...commonAddressProps,
      city: address.city,
      state: address.country,
      zip_code: address.postal_code,
      company: address.company_name || '',
      name: address.full_name,
      phone: address.phone_number,
      street1: address.address
    });
  }
  static createTaxInformationFromResponse(address) {
    if (!address) {
      return undefined;
    }
    return {
      userType: address.user_type,
      taxId: address.tax_id,
      vatNumber: address.vat_number,
      eori: address.eori_number
    };
  }

  /**
   * Returns a JSON with the payload necessary to create an Address from a ICustomsAddressApiResponse.
   *
   */
  static createApiPayload(_ref) {
    var _address$street, _address$zipCode, _address$city, _address$alpha2Code, _address$phone;
    let {
      address,
      taxInformation
    } = _ref;
    if (!address || !taxInformation) {
      return undefined;
    }
    const userType = taxInformation.userType;
    const isCompany = userType === CustomsUserType.COMPANY;
    const isPrivatePerson = userType === CustomsUserType.PRIVATE_PERSON;
    return {
      full_name: `${address.firstName} ${address.lastName}`.trim(),
      company_name: isCompany ? address.company : undefined,
      address: (_address$street = address.street1) !== null && _address$street !== void 0 ? _address$street : '',
      postal_code: (_address$zipCode = address.zipCode) !== null && _address$zipCode !== void 0 ? _address$zipCode : '',
      city: (_address$city = address.city) !== null && _address$city !== void 0 ? _address$city : '',
      country: (_address$alpha2Code = address.alpha2Code) !== null && _address$alpha2Code !== void 0 ? _address$alpha2Code : '',
      phone_number: (_address$phone = address.phone) !== null && _address$phone !== void 0 ? _address$phone : '',
      user_type: userType,
      tax_id: isPrivatePerson ? taxInformation.taxId : undefined,
      vat_number: isCompany ? taxInformation.vatNumber : undefined,
      eori_number: isCompany ? taxInformation.eori : undefined
    };
  }
}

export { CustomsUserInformationMapper };
//# sourceMappingURL=CustomsUserInformationMapper.js.map
